import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory, useParams } from 'react-router-dom';
import { notification, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import SalesOrderStore from '@/stores/SalesOrderStore';
import UserStore from '@/stores/UserStore';
import { QuoteStore } from '@/stores';
import { response } from 'msw';
import { QuoteLineItemProps } from '@/types/types';

interface IParams {
    quote_uid: any;
}

const QuoteCheckoutRedirect = observer(() => {
    const history = useHistory();

    const { quote_uid } = useParams<IParams>();
    const contact_id = UserStore.user?.default_contact?.id;

    const getOrderDraft = async (quote_uid: string, contact_id: number) => {
        try {
            const response = await QuoteStore.getQuoteByUid(quote_uid);

            const buyNowItems =
                response.line_items?.filter((item: QuoteLineItemProps) => item.quote_action === 'buy_now') || [];
            if (buyNowItems.length > 0) {
                await SalesOrderStore.createOrderDraft({
                    contact: contact_id,
                    quotes: [quote_uid],
                    line_items: buyNowItems.map((item: QuoteLineItemProps) => ({
                        name: item.name,
                        quote_has_product: item.id,
                        quantity: item.quantity,
                        unit_price: item.unit_price,
                    })),
                }).then(order => {
                    history.replace(`/my-account/orders/checkout/${order.id}/`);
                });
            }
        } catch (error) {
            history.replace('/my-account/quotes/');
        }
    };

    useEffect(() => {
        if (UserStore.isVerified) {
            if (contact_id) {
                getOrderDraft(quote_uid, contact_id).catch(() => {
                    history.replace('/my-account/quotes/');
                });
            } else {
                history.replace('/my-account/quotes/');
            }
        }
    }, [quote_uid, UserStore.isVerified]);

    return (
        <div className={'flex flex-col items-center h-full mt-10'}>
            <Spin size="large" indicator={<LoadingOutlined />} spinning={true} tip={'Redirecting...'} />
        </div>
    );
});

export default QuoteCheckoutRedirect;
